import cx from 'classnames';
import React, { ReactNode, ButtonHTMLAttributes } from 'react';

import styles from './styles.css';

interface TabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  selected?: boolean;
}

const Tab: React.FC<TabProps> = ({ children, selected, ...rest }) => {
  return (
    <button {...rest} className={cx(styles['tab'], { [styles['tab--selected']]: selected })}>
      <h4 className={styles['tab-content']}>{children}</h4>
    </button>
  );
};

export default Tab;
